import TileLayerCanvas from "./TileLayerCanvas";
import scope from "./rootScope";

export default new TileLayerCanvas( scope.tileServer +'/img/foreground/black/{z}/{x}/{y}.png');
